import React from 'react';
import S from './ChampDeTexte.module.scss';

const ChampDeTexte = ({
  value = '',
  onChange = () => {},
  placeholder = '',
  type = 'text',
  disabled = false,
  required = false,
  name = '',
  id = '',
  className = '',
  ...props
}) => {
  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <input
      type={type}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
      required={required}
      name={name}
      id={id}
      className={[S.champDeTexte, className].join(' ')}
      {...props}
    />
  );
};

export default ChampDeTexte;
